import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import commons from './assets/common';
import axios from 'axios';
import moment from './components/utils/moment';

import Swal from 'sweetalert2/dist/sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

const instance = axios.create({
	timeout: 10000, // 통신을 5초로 늘림.
	timeoutErrorMessage: '서버와의 통신이 원활하지 않습니다. 잠시 후 다시 시도해주세요.'
});

// 요청 인터셉터
instance.interceptors.request.use(
	(config) => {
		if (config.method !== 'get' && config.url.indexOf('sflog') < 0) {
			//document.querySelector('.spinner_wrap').classList.add('on');
		}
//console.log('Request Headers:', config.headers); // 요청 헤더 로그 출력
		return config;
	}, async (error) => {
		console.dir(error);
		return Promise.reject(error);
	}
);

// 응답 인터셉터
instance.interceptors.response.use(
	(response) => {
		if (response.data?.result?.message == 'OK') {
			//document.querySelector('.spinner_wrap').classList.remove('on');
		}
		return response;
	}, async (error) => {
		//document.querySelector('.spinner_wrap').classList.remove('on');
console.debug('instance.interceptors.response.error ', error);

		const status = error.response?.status;
		const statusText = error.response?.statusText;
		const requestUrl = error.config?.url || '';

		const detail_code = error.response?.data?.result?.code;
		const detail_message = error.response?.data?.result?.message;

		// 로그아웃 API 호출 시 401 에러는 무시 (무한 루프 방지)
		if (status === 401 && requestUrl.includes('/api/app/auth/logout')) {
			return Promise.reject(error);
		}

		if (status === 401) {
			//location.href = '/login';
			Swal.fire({
				title: `권한 없음`,
				text: '권한이 없습니다. 로그인 페이지로 이동합니다.',
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () { router.push('/logout?pre_page=lost_auth'); }, 100);
				}
			});
		} else if (status === 200) {
		} else {
			if (detail_code && detail_message) {
				Swal.fire({
					title: `오류코드: [${detail_code}]`,
					text: detail_message,
					icon: 'error',
					confirmButtonText: '확인',
					// allowOutsideClick: false,  // 외부 클릭 방지
					// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: true,
				});
			} else {
				Swal.fire({
					title: `오류코드: [${status}]`,
					text: `오류가 발생했습니다. 관리자에게 문의하세요. (${statusText})`,
					icon: 'error',
					confirmButtonText: '확인',
					// allowOutsideClick: false,  // 외부 클릭 방지
					// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
					returnFocus: true,
				});
			}
		}
		console.dir(error);
		return Promise.reject(error);
	}
);

window.Swal = Swal;
const toast = Swal.mixin({
	toast: true,
	position: 'top-start',
	showConfirmButton: false,
	timer: 3000,
	//timerProgressbar: true
});

window.toast = toast;
window.commons = commons;

window.axios = instance;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.moment = moment;

const app = createApp(App);


if ( process.env.NODE_ENV != 'production' ) {
	// 개발 모드에서 디버그 설정 활성화
	app.config.devtools = true;
	app.config.performance = true;

	app.config.errorHandler = (err, vm, info) => {
		console.error('Vue Error:', err);
		console.error('Vue Instance:', vm);
		console.error('Error Info:', info);
	};
}

app.use(router);
app.use(commons.install);

//app.config.globalProperties.$axios = instance; // 전역으로 axios 인스턴스를 사용

app.mount('#app');